export default __webpack_public_path__ + "static/media/dashboard_payment.a8296a75.svg";